import { render, staticRenderFns } from "./news-list-page.vue?vue&type=template&id=7725f066&"
import script from "./news-list-page.vue?vue&type=script&lang=js&"
export * from "./news-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports